export enum FiscalUsageType {
    /*
             *  1	Civile
                2	Industriale
                3	Produzione energia elettrica
                4	Autoproduzione energia elettrica
                5	Forze armate nazionali
                6	Uso cantiere, motori fissi, coltivazione idrocarburi
                7	Autotrazione
             */
    Civil = 1,
    Industrial = 2,
    EnergyProduction = 3,
    AutoEnergyProduction = 4,
    ArmedForces = 5,
    ConstructionUsage = 6,
    AutoTraction = 7
}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/enums/fiscalUsageType.ts